import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { Logo, LogoImage } from './Logo'
import { localeProps } from './TranslateToggle'
import vars from '../lib/styled'
import src from '../../static/logoWithoutMQ_2017_PNG.png'

const NavBarWrapper = styled.nav`
  align-items: center;
  background-color: #fff;
  // border-bottom: 2px solid ${vars.accent};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 100%;
  position: relative;
  width: 100%;
  z-index: 10;
`

const NavBarMenu = styled.ul`
  align-items: center;
  display: flex;
  justify-items: flex-end;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: ${vars.breakpoint.laptop}) {
    display: none;
  }
`

const NavBarMenuItem = styled.li`
  display: inline-block;
`

const NavBarMenuItemLink = styled(Link)`
  color: ${vars.secondary};
  display: block;
  font-weight: 400;
  font-size: 1em;
  line-height: 2rem;
  padding: 0 0.85vw;
  position: relative;
  text-decoration: none;

  &::after {
    background-color: ${vars.accent};
    content: '';
    display: block;
    height: 2px;
    left: 50%;
    opacity: 0;
    position: absolute;
    top: 100%;
    transform: translateX(-50%);
    transition: all 500ms;
    visibility: hidden;
    width: 0;
  }

  &:hover {
    &::after {
      opacity: 1;
      visibility: visible;
      width: 30%;
    }
  }

  &.active {
    color: ${vars.accent};

    &::after {
      opacity: 1;
      visibility: visible;
      width: 40%;
    }
  }
`

const NavBarLogo = ({ locale }) => (
  <Logo aria-label="site home" to={locale}>
    <LogoImage src={src} alt="Marcangelo Logo" />
  </Logo>
)

NavBarLogo.propTypes = {
  locale: PropTypes.string.isRequired,
}

const NavBar = ({ children, menuItems, locale }) => (
  <NavBarWrapper>
    <NavBarLogo locale={`/${locale}/`} />
    <div>
      {menuItems && (
        <NavBarMenu role="menu">
          {menuItems[locale.replace(/-/, '_')].map((obj) => {
            const url = `/${locale}${obj.link}`
            return (
              <NavBarMenuItem key={url} role="none">
                <NavBarMenuItemLink
                  partiallyActive
                  activeClassName="active"
                  role="menuitem"
                  to={url}
                >
                  {obj.label}
                </NavBarMenuItemLink>
              </NavBarMenuItem>
            )
          })}
        </NavBarMenu>
      )}
    </div>
    {children}
  </NavBarWrapper>
)

const menuItemShape = PropTypes.arrayOf(
  PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string,
  }),
)

/** shared with offcanvas */
export const navigationPropTypes = {
  menuItems: PropTypes.shape({
    en_ca: menuItemShape,
    en_us: menuItemShape,
    fr_ca: menuItemShape,
  }).isRequired,
  link: PropTypes.string.isRequired,
  locale: localeProps,
  hrefLangLabel: PropTypes.oneOf(['EN', 'FR']).isRequired,
}

NavBar.propTypes = navigationPropTypes
NavBar.defaultProps = {
  locale: '/',
}

export default NavBar
